<template>
  <div class="d-flex align-items-center gap-3">
    <router-link to="/notifications" class="nav-btn position-relative">
      <span class="icon-notification-bing"></span>
      <span v-if="unreadCount > 0" class="notification-badge">{{ unreadCount }}</span>
    </router-link>
    <div class="dropdown dropdown-profile">
      <button
        class="nav-btn dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <span class="icon-frame"></span>
      </button>
      <div class="dropdown-menu">
        <h4 class="username">{{ username || 'نام و نام خانوادگی کاربر' }}</h4>
        <ul>
          <li class="py-1">
            <router-link
              to="/profile/info"
              class="dopdown-link d-flex align-items-center justify-content-between gap-2"
            >
              <p class="d-flex align-items-center gap-1">
                <span class="icon-edit"></span> اطلاعات
              </p>
            </router-link>
          </li>
          <li class="py-1">
            <router-link
              to="/profile/change-password"
              class="dopdown-link d-flex align-items-center justify-content-between gap-2"
            >
              <p class="d-flex align-items-center gap-1">
                <span class="icon-password-check"></span> تغییر رمز عبور
              </p>
            </router-link>
          </li>
          <li class="py-1">
            <router-link
              to="/profile/security"
              class="dopdown-link d-flex align-items-center justify-content-between gap-2"
            >
              <p class="d-flex align-items-center gap-1">
                <span class="icon-password-check"></span> امنیت (رمز تایید و ۲FA)
              </p>
            </router-link>
          </li>
          <li class="py-1">
            <a
              href="#"
              class="dopdown-link d-flex align-items-center justify-content-between gap-2"
            >
              <div class="d-flex align-items-center gap-1">
                <span class="icon-theme"></span> انتخاب تم
              </div>
              <div class="toggle toggle-mood">
                <label for="toggle-mode-cb"></label>
              </div>
            </a>
          </li>
          <li class="py-1">
            <a
              href="#"
              class="dopdown-link d-flex align-items-center justify-content-between gap-2"
              @click.prevent="handleLogout"
            >
              <p class="d-flex align-items-center gap-1">
                <span class="icon-logout"></span> خروج از حساب کاربری
              </p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { get } from '@/api'

export default {
  name: 'ProfileDropdown',
  props: {
    username: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      unreadCount: 0
    }
  },
  mounted() {
    this.fetchUnreadCount()
    // Update unread count every 30 seconds
    this.interval = setInterval(() => {
      this.fetchUnreadCount()
    }, 30000)
  },
  beforeUnmount() {
    if (this.interval) {
      clearInterval(this.interval)
    }
  },
  methods: {
    handleLogout() {
      // Emit logout event to parent component
      this.$emit('logout');
    },
    async fetchUnreadCount() {
      try {
        const response = await get('/notifications/unread-count')
        if (response.data.success) {
          this.unreadCount = response.data.data.unread_count
        }
      } catch (error) {
        // Silently fail - don't show error for this background operation
        console.log('Could not fetch unread count')
      }
    }
  }
}
</script>

<style scoped>
.position-relative {
  position: relative;
}

.notification-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: #ff4444;
  color: white;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: bold;
  border: 2px solid var(--bg-primary);
}

.notification-badge:empty {
  display: none;
}
</style>
